import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../SidebarItem";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerShowItem.propTypes = {
    retailerId: PropTypes.string.isRequired
};

function RetailerShowItem({retailerId}) {
    const {currentPath} = useContext(SidebarContext);

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_SHOW(retailerId)}
            selected={currentPath === MarketplaceRoutes.RETAILER_SHOW(retailerId)}
        >
            <FormattedMessage id='sidebar.item.dashboard' />
        </SidebarItem>
    )
}

export default RetailerShowItem;
